import styled from 'styled-components';

const SvgLogo = styled.svg<{ fill?: string }>`
  cursor: pointer;
  fill: ${({ fill, theme }) => fill || theme.colors.black} !important;
`;

interface IGoatLogo {
  className?: string;
  fill?: string;
  height?: number;
  width?: number;
}

export const GoatLogo = ({ className, fill, height, width }: IGoatLogo) => {
  return (
    <SvgLogo
      className={className}
      fill={fill}
      width={`${width}px` || '368px'}
      height={`${height}px` || '84px'}
      version="1.1"
      id="GOAT_logo"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 368 84"
    >
      <g>
        <path d="M42.2,50.7h23.4v12.2c-5.4,6.2-13,10.5-23.3,10.5c-17.7,0-30.4-13.2-30.4-31.4c0-18.4,12.8-31.4,30.4-31.4c10.8,0,19.9,5.4,24.5,12.2l8.5-7.6C67.7,5.8,56.7,0,42.3,0C18.6,0,0,17.8,0,42s18.6,42,42.2,42c15.5,0,27.9-7.7,35.1-18.2V40.2H42.2V50.7z" />
        <path d="M148.2,0C124.6,0,106,17.8,106,42s18.6,42,42.2,42c23.7,0,42.2-17.8,42.2-42S171.9,0,148.2,0z M148.2,73.4c-17.5,0-30.4-13.2-30.4-31.4c0-18.4,12.8-31.4,30.4-31.4c17.5,0,30.5,13,30.5,31.4C178.7,60.2,165.8,73.4,148.2,73.4z" />
        <path d="M243.2,1.7l-34.9,80.5h11.8l9.8-22.3h38.2l9.8,22.3h11.8L254.9,1.7H243.2z M234.5,49.4L249,16.1h0.1l14.4,33.3H234.5z" />
        <polygon points="300.1,1.7 300.1,12.3 327.7,12.3 327.7,82.3 339.5,82.3 339.5,12.3 367,12.3 367,1.7" />
      </g>
    </SvgLogo>
  );
};
